
import React from 'react';
import './ParameterDialog.css';
import ParameterControls from './ParameterControls';

const ParameterDialog = ({ isOpen, onClose, onConfirm, ...props }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="dialog-overlay">
      <div className="dialog parameter-dialog">
        <h2>Charting Parameter</h2>
        <ParameterControls {...props} />
        <div className="dialog-buttons">
          <p className="warning-message">This chart is for illustrative purposes only and does not reflect actual results.</p>
          <div className="button-group">
            <button onClick={onConfirm} className="apply-btn">
              Draw Chart
            </button>
            <button onClick={onClose} className="cancel-btn">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParameterDialog;
